import { classNamesWithMerge as cn } from "hyam-core/utils/tailwindMerge";

const section_inside_accordion =
  "mb-3 pb-2 pt-1 border-b border-b-hyam-white";

export const styles = {
  section_action_items_social: cn(
    "flex justify-center items-center gap-16",
    "mb-6 pb-6",
    "border-b border-b-hyam-white",
  ),

  layout_container:
    "bg-hyam-black hyam-layout-container pb-6 w-full border-t-hyam-white border-t",
  container: "hyam-layout",
  section_links: cn(section_inside_accordion),
  section_links_link:
    "hyam-text-small block uppercase text-hyam-white mb-4",

  section_rich_text: cn(
    section_inside_accordion,
    // "pb-6",
    // NOTE: blank lines between address blocks come from the trailing <br> that
    // Prismic renders for a trailing newline; do not restyle <br> or it collapses.
  ),
  section_rich_text_item: "mb-6",
  section_rich_text_button: cn(
    "mt-4 mb-0",
    "text-hyam-white uppercase",
    "hover:decoration-hyam-white hyam-animate-text-white",
  ),

  // no mb-0: keep hyam-text-small's mb-6 so the address paragraphs stay spaced apart
  rich_text_all: "text-hyam-white",
  rich_text_paragraph: "hyam-text-small",
  // mb-0: links sit inside a paragraph, so the block gap stays on the <p>, not each link
  rich_text_hyperlink: "hyam-text-small mb-0",

  section_action_items: "",
  section_action_item_social_link: "h-6",
  section_action_button: "w-full sm:w-full",

  bottom_logo_container: "",

  accordion_container: "py-3",
  accordion_item_title: "items-center py-3",

  item_title:
    "text-hyam-white hyam-text-small uppercase font-semibold leading-0 mb-0",

  legal_links_container:
    "flex justify-between mt-4",
  legal_link:
    "hyam-text-caption text-hyam-white",
};

export type HyamPrismicDocumentFooterMobileStyles =
  typeof styles;
